module.exports = __webpack_public_path__ + "img/img14.56e03d66.png";